'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxRouter = require('redux-router');

var _caligramReact = require('caligram-react');

var _audiences = require('redux/modules/audiences');

var _organizations = require('redux/modules/organizations');

var _regions = require('redux/modules/regions');

var _tags = require('redux/modules/tags');

var _types = require('redux/modules/types');

var _venues = require('redux/modules/venues');

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventListContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    events: state.events.data,
    loading: state.events.loading,
    location: state.router.location,
    pagination: state.events.pagination,
    selectedAudiences: state.audiences.selected,
    selectedOrganizations: state.organizations.selected,
    selectedRegions: state.regions.selected,
    selectedTags: state.tags.selected,
    selectedTypes: state.types.selected,
    selectedVenues: state.venues.selected
  };
}, {
  push: _reduxRouter.push,
  setSelectedAudiences: _audiences.setSelected,
  setSelectedOrganizations: _organizations.setSelected,
  setSelectedRegions: _regions.setSelected,
  setSelectedTags: _tags.setSelected,
  setSelectedTypes: _types.setSelected,
  setSelectedVenues: _venues.setSelected
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(EventListContainer, _Component);

  function EventListContainer() {
    (0, _classCallCheck3.default)(this, EventListContainer);
    return (0, _possibleConstructorReturn3.default)(this, (EventListContainer.__proto__ || (0, _getPrototypeOf2.default)(EventListContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventListContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateQuery({
        mapView: false,
        page: 1
      });
    }
  }, {
    key: 'updateQuery',
    value: function updateQuery(query) {
      var location = this.props.location;

      var newQuery = (0, _extends3.default)({}, location.query, query);
      var newLocation = (0, _extends3.default)({}, location, {
        query: newQuery
      });

      this.context.router.push(newLocation);
    }
  }, {
    key: 'handlePageChange',
    value: function handlePageChange(page) {
      var _props = this.props,
          location = _props.location,
          push = _props.push; // eslint-disable-line no-shadow

      var query = (0, _extends3.default)({}, location.query, {
        page: page
      });

      push({ pathname: '/evenements', query: query });
    }
  }, {
    key: 'handleRemoveItem',
    value: function handleRemoveItem(item) {
      var _props2 = this.props,
          location = _props2.location,
          push = _props2.push; // eslint-disable-line no-shadow

      var selected = {
        audiences: this.props.selectedAudiences,
        organizations: this.props.selectedOrganizations,
        regions: this.props.selectedRegions,
        types: this.props.selectedTypes,
        tags: this.props.selectedTags,
        venues: this.props.selectedVenues
      };
      var select = {
        audiences: this.props.setSelectedAudiences,
        organizations: this.props.setSelectedOrganizations,
        regions: this.props.setSelectedRegions,
        types: this.props.setSelectedTypes,
        tags: this.props.setSelectedTags,
        venues: this.props.setSelectedVenues
      };
      var newQuery = (0, _extends3.default)({}, location.query);

      if (item.group === 'range') {
        delete newQuery.range;
      } else {
        newQuery = (0, _utils.updateSelections)(item, selected, select);
      }

      push({ pathname: '/evenements', query: newQuery });
    }
  }, {
    key: 'handleClear',
    value: function handleClear() {
      [this.props.setSelectedAudiences, this.props.setSelectedOrganizations, this.props.setSelectedRegions, this.props.setSelectedTypes, this.props.setSelectedTags, this.props.setSelectedVenues].forEach(function (method) {
        return method([]);
      });

      this.props.push({ pathname: '/evenements' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          events = _props3.events,
          loading = _props3.loading,
          location = _props3.location,
          pagination = _props3.pagination,
          title = _props3.title;
      var _props4 = this.props,
          selectedAudiences = _props4.selectedAudiences,
          selectedOrganizations = _props4.selectedOrganizations,
          selectedRegions = _props4.selectedRegions,
          selectedTypes = _props4.selectedTypes,
          selectedTags = _props4.selectedTags,
          selectedVenues = _props4.selectedVenues;
      var moment = this.context.moment;


      var range = [];
      if (location.query.range) {
        var date = {
          id: location.query.range,
          label: moment(location.query.range.split(',')[0]).format('Do MMMM YYYY'),
          tag: 'Date',
          group: 'range'
        };
        range.push(date);
      }

      var selectedItems = range.concat(selectedAudiences).concat(selectedOrganizations).concat(selectedRegions).concat(selectedTypes).concat(selectedTags).concat(selectedVenues);

      var properties = {
        clearFilters: this.handleClear.bind(this),
        currentPage: pagination.current_page,
        events: events,
        filters: selectedItems,
        pageChange: this.handlePageChange.bind(this),
        removeFilter: this.handleRemoveItem.bind(this),
        totalPages: pagination.total_pages,
        loading: loading,
        title: title
      };

      return this.props.children(properties);
    }
  }]);
  return EventListContainer;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.func,
  events: _react.PropTypes.array,
  loading: _react.PropTypes.bool,
  location: _react.PropTypes.object,
  pagination: _react.PropTypes.object,
  push: _react.PropTypes.func.isRequired,
  selectedAudiences: _react.PropTypes.array.isRequired,
  selectedOrganizations: _react.PropTypes.array.isRequired,
  selectedRegions: _react.PropTypes.array.isRequired,
  selectedTags: _react.PropTypes.array.isRequired,
  selectedTypes: _react.PropTypes.array.isRequired,
  selectedVenues: _react.PropTypes.array.isRequired,
  setSelectedAudiences: _react.PropTypes.func.isRequired,
  setSelectedOrganizations: _react.PropTypes.func.isRequired,
  setSelectedRegions: _react.PropTypes.func.isRequired,
  setSelectedTags: _react.PropTypes.func.isRequired,
  setSelectedTypes: _react.PropTypes.func.isRequired,
  setSelectedVenues: _react.PropTypes.func.isRequired,
  title: _react.PropTypes.string
}, _class2.contextTypes = {
  moment: _react.PropTypes.func,
  router: _react.PropTypes.object
}, _class2.defaultProps = {
  children: function children(props) {
    return _react2.default.createElement(_caligramReact.EventList, props);
  }
}, _temp)) || _class);
exports.default = EventListContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EventListContainer.js
// module id = 1178
// module chunks = 0